/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DeletedTombstoneContainer_comment = {
    readonly deleted: boolean | null;
    readonly id: string;
    readonly " $refType": "DeletedTombstoneContainer_comment";
};
export type DeletedTombstoneContainer_comment$data = DeletedTombstoneContainer_comment;
export type DeletedTombstoneContainer_comment$key = {
    readonly " $data"?: DeletedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"DeletedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deleted",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '83bd9b6a87bf56a159de50bd946fe43b';
export default node;
